export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "AI搭載暗号通貨取引",
    "description": "高度な取引シグナルと自動ポートフォリオ管理",
  },
  "navigation": {
    "dashboard": "ダッシュボード",
    "trading": "取引",
    "signals": "シグナル",
    "apiCredentials": "API認証情報",
    "autoTrading": "自動取引",
    "tierManagement": "ティア管理",
    "referrals": "紹介",
    "accessSecurity": "アクセスとセキュリティ",
    "settings": "設定",
    "help": "ヘルプとサポート",
    "login": "ログイン",
    "register": "登録",
    "logout": "ログアウト",
    "home": "ホーム",
  },
  "auth": {
    "layout": {
      "signInToAccount": "アカウントにサインイン",
      "or": "または",
      "createNewAccount": "新しいアカウントを作成"
    },
    "login": {
      "title": "おかえりなさい",
      "subtitle": "メールアドレスとパスワードを入力してサインインしてください",
      "email": "メール",
      "password": "パスワード",
      "emailPlaceholder": "name@example.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "ログイン状態を保持",
      "forgotPassword": "パスワードを忘れましたか？",
      "signIn": "サインイン",
      "noAccount": "アカウントをお持ちでないですか？",
      "signUp": "サインアップ",
      "googleSignIn": "Googleで続行",
      "orContinueWith": "または次で続行",
      "fillAllFields": "すべてのフィールドを入力してください",
      "loginSuccess": "ログインに成功しました！",
      "loginFailed": "ログインに失敗しました",
      "loginFailedDescription": "ログインに失敗しました",
      "googleLoginFailed": "Googleログインの開始に失敗しました",
      "bySigningIn": "サインインすることで、以下に同意したことになります",
      "termsOfService": "利用規約",
      "privacyPolicy": "プライバシーポリシー",
      "and": "および"
    },
    "register": {
      "title": "アカウント作成",
      "subtitle": "アカウントを作成するために情報を入力してください",
      "firstName": "名",
      "lastName": "姓",
      "email": "メールアドレス",
      "password": "パスワード",
      "confirmPassword": "パスワード確認",
      "agreeTerms": "続行をクリックすることで、以下に同意します",
      "createAccount": "アカウント作成",
      "hasAccount": "すでにアカウントをお持ちですか？",
      "signIn": "サインイン",
      "orContinueWith": "または次で続行",
      "googleSignUp": "Googleでサインアップ",
      "termsOfService": "利用規約",
      "privacyPolicy": "プライバシーポリシー",
      "referralCode": "紹介コード（オプション）",
      "placeholders": {
        "firstName": "太郎",
        "lastName": "田中",
        "email": "名前@例.com",
        "password": "パスワードを入力してください",
        "confirmPassword": "パスワードを確認してください",
        "referralCode": "紹介コードを入力してください"
      },
      "validation": {
        "minLength": "パスワードは8文字以上である必要があります",
        "uppercase": "パスワードには大文字を1文字以上含める必要があります",
        "lowercase": "パスワードには小文字を1文字以上含める必要があります",
        "number": "パスワードには数字を1文字以上含める必要があります",
        "specialChar": "パスワードには特殊文字を1文字以上含める必要があります"
      },
      "errors": {
        "invalidReferralCode": "無効な紹介コード",
        "referralValidationFailed": "紹介コードを検証できませんでした。接続を確認してもう一度お試しください。",
        "googleLoginFailed": "Googleログインに失敗しました",
        "googleLoginFailedTitle": "Googleログインに失敗しました",
        "fillAllFields": "すべてのフィールドを入力してください",
        "requirementsNotMet": "パスワード要件が満たされていません",
        "passwordsDoNotMatch": "パスワードが一致しません",
        "registrationFailed": "登録に失敗しました",
        "failedToCreateAccount": "アカウントの作成に失敗しました",
        "emailAlreadyRegistered": "メールアドレスが既に登録されています",
        "emailAlreadyRegisteredDescription": "このメールアドレスのアカウントが既に存在します。ログインをお試しください。",
        "connectionError": "接続エラー",
        "connectionErrorDescription": "サーバーに接続できませんでした。インターネット接続を確認してもう一度お試しください。",
        "referralCodeError": "紹介コードエラー",
        "referralCodeErrorDescription": "紹介コードの処理中に問題が発生しました。アカウントは作成されます。",
        "failedToResendEmail": "確認メールの再送信に失敗しました",
        "failedToResendEmailTitle": "メールの再送信に失敗しました",
        "tryAgainLater": "後でもう一度お試しください。"
      },
      "success": {
        "title": "登録成功！",
        "description": "アカウントを確認するためにメールをチェックしてください。"
      },
      "verification": {
        "title": "メールを確認してください",
        "description": "{{email}}に確認リンクを送信しました",
        "nextSteps": "次のステップ：",
        "step1": "1. メールの受信箱を確認",
        "step2": "2. 確認リンクをクリック",
        "step3": "3. ここに戻ってログイン",
        "sending": "送信中...",
        "resendButton": "確認メールを再送信",
        "backToLogin": "ログインに戻る",
        "emailSentTitle": "確認メールを送信しました",
        "emailSentDescription": "確認リンクのためにメールをチェックしてください。"
      },
      "referral": {
        "validating": "紹介コードを検証中...",
        "validCode": "{{referrer}}からの有効な紹介コード"
      }
    },
    "passwordRequirements": {
      "title": "パスワード要件",
      "length": "8文字以上",
      "uppercase": "大文字1文字",
      "lowercase": "小文字1文字",
      "number": "数字1文字",
      "special": "特殊文字1文字",
    },
    "errors": {
      "invalidCredentials": "無効なメールアドレスまたはパスワード",
      "emailRequired": "メールアドレスが必要です",
      "passwordRequired": "パスワードが必要です",
      "passwordTooShort": "パスワードは8文字以上である必要があります",
      "passwordsNotMatch": "パスワードが一致しません",
      "emailInvalid": "有効なメールアドレスを入力してください",
      "termsRequired": "利用規約に同意する必要があります",
    }
  },
  "dashboard": {
    "title": "ダッシュボード",
    "welcome": "おかえりなさい!",
    "overview": "概要",
    "trading": "取引",
    "tier": "ティア",
    "balance": "残高",
    "pnlToday": "損益",
    "totalTrades": "総取引数",
    "winRate": "勝率",
    "activeSignals": "アクティブシグナル",
    "tradingOverview": "取引概要",
    "quickActions": "クイックアクション",
    "viewSignals": "シグナルを表示",
    "autoTrading": "自動取引",
    "autoTradingDescription": "取引シグナルを自動実行",
    "currentTier": "現在のティア",
    "progressTo": "ティア{{tier}}への進捗",
    "yourBenefits": "あなたの特典",
    "advancedSignals": "高度な取引シグナル",
    "autoTradingFeatures": "自動取引機能",
    "prioritySupport": "優先サポート",
    "monthlyRate": "月間収益率",
    "profitShare40": "40%利益分配",
    "profitShare20": "20%利益分配",
    "profitShare10": "10%利益分配",
    "verifyingNFT": "NFT所有権を確認中...",
    "debt": "債務",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: 読み込み中...",
      "unavailable": "BTC/USDT: --",
      "connecting": "接続中...",
      "live": "ライブ",
      "error": "エラー ({{count}})",
      "24h": "24時間",
    },
    "controls": {
      "turnOn": "オン",
      "turnOff": "オフ",
      "paperAutoTrading": "ペーパー自動取引",
    },
    "forecast": {
      "title": "価格予測",
      "refresh": "更新",
      "errorLoading": "チャート読み込みエラー",
      "retry": "再試行",
      "noData": "利用可能なチャートデータがありません",
    },
    "tradingChart": {
      "forecast": "予測",
      "upperBound": "上限",
      "lowerBound": "下限",
      "support": "サポート",
      "resistance": "レジスタンス",
      "entry": "エントリー",
      "stopLoss": "ストップロス",
      "takeProfit": "テイクプロフィット",
      "partialTakeProfit": "部分利確",
      "liquidation": "清算",
      "locked": "ロック済み",
      "positionLevelDialogTitle": "{{level}}の更新を確認",
      "positionLevelDialogDescription": "{{symbol}} {{side}}の{{level}}を{{currentPrice}}から{{newPrice}}に設定しますか？",
      "positionLevelDelta": "変化: {{delta}}%",
      "positionLevelConfirm": "{{level}}を更新",
      "positionLevelCancel": "キャンセル",
      "positionLevelProcessing": "更新中...",
      "positionLevelSuccess": "{{level}}を更新しました",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · 新しい{{level}}: {{price}}",
      "positionLevelFailure": "{{level}}の更新に失敗しました",
      "positionLevelFailureDesc": "以前のレベルに戻しました。{{error}}",
      "dragHint": "ドラッグして移動 · 離して確認",
      "indicators": {
        "title": "インジケーター",
        "overlays": "オーバーレイ",
        "panes": "ペイン",
        "levels": "レベル",
        "keyLevels": "キーレベル (S/R)",
        "reset": "インジケーターをリセット",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "ボリンジャーバンド (20, 2)",
        "bbUpper": "ボリンジャー上限",
        "bbMiddle": "ボリンジャー中央",
        "bbLower": "ボリンジャー下限",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "MACDシグナル",
      },
      "drawing": {
        "toolbar": "描画ツール",
        "select": "選択",
        "magnetMode": "マグネット: {{mode}}",
        "stayInDrawingMode": "描画モードを維持",
        "hideAll": "すべての描画を非表示",
        "showAll": "すべての描画を表示",
        "undo": "元に戻す",
        "redo": "やり直す",
        "deleteSelected": "選択した描画を削除",
        "clearAll": "すべての描画を消去",
        "moreTools": "その他の描画ツール",
        "export": "描画をエクスポート",
        "import": "描画をインポート",
        "textPrompt": "描画テキストを入力",
        "loadFailure": "描画ツールを利用できません",
        "importEmpty": "このファイルに描画が見つかりません",
        "importSuccess": "{{count}} 件の描画をインポートしました",
        "importFailure": "描画のインポートに失敗しました",
        "clearConfirmTitle": "すべての描画を消去しますか？",
        "clearConfirmDescription": "現在のシンボルと時間足のすべての描画を削除します。この操作は元に戻せません。",
        "categories": {
          "lines": "ライン",
          "channels": "チャネル",
          "fibonacci": "フィボナッチとギャン",
          "patterns": "パターン",
          "elliott": "エリオット",
          "forecasting": "予測と測定",
          "volume": "出来高",
          "annotations": "注釈",
          "shapes": "図形",
          "cycles": "サイクル",
          "regression": "回帰",
        },
        "tools": {
          "trend-line": "トレンドライン",
          "horizontal-line": "水平線",
          "vertical-line": "垂直線",
          "ray": "レイ",
          "parallel-channel": "平行チャネル",
          "fib-retracement": "フィボナッチ・リトレースメント",
          "trend-based-fib-extension": "トレンド基準フィボナッチ拡張",
          "rectangle": "矩形",
          "text": "テキスト",
          "arrow": "矢印",
          "brush": "ブラシ",
          "price-range": "価格範囲",
          "long-position": "ロングポジション",
          "short-position": "ショートポジション",
        },
      },
    },
    "realTimePerformance": "リアルタイムパフォーマンス",
    "riskSettings": {
      "title": "リスク管理設定",
      "paperTradingTitle": "リスク管理設定 - デモ取引",
      "loading": "リスク設定を読み込み中...",
      "investmentPercentage": "投資割合",
      "investmentDescription": "取引に使用する残高の割合 (0% - 10%)",
      "leverage": "レバレッジ",
      "leverageDescription": "最大: ティア{{tier}} + {{exchange}} {{market}}で{{max}}x",
      "paperTradingLeverageDesc": "デモモードでは、テスト目的で任意のレバレッジ設定を使用できます",
      "exchange": "取引所: ",
      "configureCredentials": "API認証情報で設定",
      "warningZeroInvestment": "取引を有効にするには投資割合 > 0%を選択してください",
      "paperTradingNote": "デモ取引モード - ティア制限は適用されません",
      "saveSettings": "設定を保存",
      "saving": "保存中...",
      "resetToSafe": "安全モードにリセット",
      "confirmSaveTitle": "リスク設定の確認",
      "confirmSaveDesc": "これらのリスク設定を保存してもよろしいですか？\n\n投資：{{investment}}%\nレバレッジ：{{leverage}}x\nモード：{{mode}}",
      "confirmSave": "設定を保存",
      "saveSuccess": "設定が保存されました",
      "saveSuccessDesc": "リスク管理設定が正常に保存されました。",
      "saveError": "保存に失敗しました",
      "tradingStrategy": "取引戦略",
      "strategyActive": "スタンダード戦略",
      "strategyConservative": "ニューラルAI戦略",
      "strategyActiveBadge": "推奨",
      "strategyActiveDesc": "ML価格予測に基づくより頻繁な取引。1日あたり3〜8のシグナルを生成し、75〜80%の予想精度。より多くの機会を求め、適度な活動を処理できるトレーダーに最適です。",
      "strategyConservativeDesc": "厳格な確認を伴う、より少ないが高信頼度の取引。1日あたり1〜3のシグナルを生成し、85〜90%の予想精度。量より質を重視する保守的なトレーダーに最適です。",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Grid Trading を有効化",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Trailing Stop を有効化",
      "signalsPerDay": "1日あたりのシグナル数",
      "expectedAccuracy": "予想精度",
      "tradeFrequency": "取引頻度",
      "riskLevel": "リスクレベル",
      "profitPotential": "利益の可能性",
      "bestFor": "最適な対象",
      "activeTraders": "より多くの機会を求めるアクティブなトレーダー",
      "conservativeTraders": "量より質を好む保守的なトレーダー",
      "high": "高",
      "low": "低",
      "moderate": "中程度",
      "higher": "より高い",
      "viewComparison": "比較を表示",
      "hideComparison": "比較を非表示",
      "testForecastStrategy": "予測戦略をテスト",
      "testingStrategy": "戦略をテスト中...",
      "testStrategyDesc": "予測戦略が今取引を開くかどうかをテストするにはクリックしてください",
      "paperSettingsError": "ペーパー設定エラー",
      "paperSettingsErrorDesc": "ペーパー取引のリスク設定の読み込みに失敗しました。",
      "settingsLoadError": "設定読み込みエラー",
      "settingsLoadErrorDesc": "リスク設定の読み込みに失敗しました。ページを更新してください。",
      "configurationRequired": "設定が必要",
      "configurationRequiredDesc": "戦略をテストする前に投資割合を0%以上に設定してください。",
      "noTradeSignal": "取引シグナルなし",
      "noTradeSignalDesc": "予測では不十分な動きを示しています。上昇：{{upward}}%、下降：{{downward}}%。取引をトリガーするには>0.5%が必要です。",
      "strategyTestSuccessful": "戦略テスト成功",
      "strategyTestSuccessfulDesc": "{{direction}}シグナルが{{movement}}%の潜在的な動きで検出されました。{{result}}",
      "paperTradeOpened": "ペーパー取引が正常に開かれました！",
      "tradeSimulationCompleted": "取引シミュレーションが完了しました。",
      "strategyTestFailed": "戦略テスト失敗",
      "strategyTestFailedDesc": "戦略テスト中に不明なエラーが発生しました。",
      "strategyTestError": "戦略テストエラー",
      "strategyTestErrorDesc": "予測戦略のテストに失敗しました。",
    },
    "activePositions": {
      "title": "アクティブポジション",
      "tabs": {
        "all": "すべて",
        "app": "アプリ",
        "external": "外部",
      },
      "refresh": "更新",
      "errorLoading": "アクティブポジション読み込みエラー",
      "retry": "再試行",
      "noPositions": "アクティブポジションがありません。",
      "noPositionsDesc": "取引を開始するか自動取引を有効にすると、アクティブな取引ポジションがここに表示されます。",
      "noAppPositions": "アクティブなアプリポジションがありません。",
      "noExternalPositions": "アクティブな外部ポジションがありません。",
      "addCredentialsWarning": " 外部ポジションを表示するにはAPI認証情報を追加してください",
      "externalError": "❌ 外部ポジションエラー: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "アプリ: {{app}} | 外部: {{external},",
      "fields": {
        "size": "サイズ",
        "entryPrice": "エントリー価格",
        "currentPrice": "現在価格",
        "margin": "マージン",
        "liquidationPrice": "清算価格",
        "marginRate": "マージン率",
        "takeProfit": "利確",
        "stopLoss": "損切",
        "roi": "ROE",
        "none": "なし",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "アプリポジション",
        "externalPositions": "外部ポジション",
      },
      "headers": {
        "symbol": "シンボル",
        "size": "サイズ",
        "entryPrice": "エントリー価格",
        "markPrice": "マーク価格",
        "liqPrice": "清算価格",
        "margin": "マージン",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "アクション",
      },
      "close": "閉じる",
      "closing": "閉じています...",
      "featureNotAvailable": "機能が利用できません",
      "positionClosingPaperOnly": "ポジションの決済は現在ペーパー取引モードでのみ利用可能です。",
      "tpSlPaperOnly": "TP/SLは現在ペーパー取引モードでのみ利用可能です。",
      "positionClosed": "ポジション決済",
      "positionClosedDesc": "ポジションが正常に決済されました。PnL: ${{pnl}}",
      "errorClosingPosition": "ポジション決済エラー",
      "errorClosingPositionDesc": "ポジションの決済に失敗しました",
      "takeProfitSet": "利確設定",
      "takeProfitSetDesc": "利確が${{price}}に設定されました",
      "errorSettingTakeProfit": "利確設定エラー",
      "errorSettingTakeProfitDesc": "利確の設定に失敗しました",
      "stopLossSet": "損切り設定",
      "stopLossSetDesc": "損切りが${{price}}に設定されました",
      "errorSettingStopLoss": "損切り設定エラー",
      "errorSettingStopLossDesc": "損切りの設定に失敗しました",
      "position": "ポジション",
      "positions": "ポジション",
      "allPositions": "全ポジション",
      "noApiCredentials": "API認証情報が接続されていません",
    },
    "debug": {
      "testSuccessful": "デバッグ取引テスト成功",
      "paperTradeOpened": "ペーパー取引が正常に開かれました！",
      "tradeSimulationCompleted": "取引シミュレーションが完了しました。",
      "testFailed": "デバッグ取引テスト失敗",
      "unknownError": "デバッグ取引テスト中に不明なエラーが発生しました。",
      "testError": "デバッグテストエラー",
      "testErrorDesc": "取引開始のテストに失敗しました。",
    },
    "profitShare": {
      "title": "利益分配追跡",
      "loading": "利益分配データを読み込み中...",
      "noData": "利益分配データがありません。取引を開始して利益を追跡してください。",
      "balanceOverview": "残高概要",
      "initialBalance": "初期残高:",
      "currentBalance": "現在残高:",
      "netDeposits": "純入金:",
      "profitAnalysis": "利益分析",
      "tradingProfit": "取引利益:",
      "trueProfit": "真の利益:",
      "profitPercentage": "利益率:",
      "profitShareInfo": "利益分配",
      "tierRate": "ティア{{tier}}レート:",
      "amountOwed": "支払い額:",
      "status": "ステータス:",
      "profitable": "アカウントは利益状態です - 利益分配は初期残高を超える利益に適用されます",
      "notProfitable": "アカウントはまだ利益を出していません - 残高が初期 + 入金を超えるまで利益分配はありません",
      "profitableDescription": "残高が初期資金と入金額を上回っています。利益分配手数料は上記の利益額に基づいて計算されます。",
      "notProfitableDescription": "初期資金と入金額を上回るまで取引を続けてください。それまでは利益分配は発生しません。",
      "paymentRequired": "支払い必要",
      "paymentDescription": "${{amount}}の利益分配手数料の支払いがあります。",
      "payNow": "今すぐ支払う",
      "viewDetails": "利益分配の詳細を見る",
    },
    "tradingHistory": {
      "title": "取引履歴（アプリ取引のみ）",
      "description": "DeepTradeプラットフォームで開始された取引を表示",
      "loading": "読み込み中...",
      "headers": {
        "date": "日付",
        "symbol": "シンボル",
        "side": "方向",
        "size": "サイズ",
        "entry": "エントリー",
        "exit": "エグジット",
        "fees": "手数料",
        "pnl": "総損益",
        "status": "ステータス",
      },
      "noHistory": "取引履歴が見つかりません。取引を開始してここで履歴を確認してください。",
      "pagination": "{{pages}}ページ中{{page}}ページ（合計{{total}}取引）",
      "previous": "前へ",
      "next": "次へ",
    },
    "blockedUser": {
      "title": "取引がブロックされました:",
      "message": "ティア（{{tier}}）の未払い利益分配。未払い額: ${{owed}}。続行するには残高を決済してください。",
    },
    "tooltips": {
      "balance": "接続された取引所からの現在の口座残高。",
      "pnlToday": "本日クローズされた取引からの実現損益。",
      "monthlyRate": "パーセンテージとしての月次リターン率。",
      "winRate": "利益を上げた取引のパーセンテージ。"
    }
  },
  "trading": {
    "title": "取引",
    "signals": "シグナル",
    "positions": "ポジション",
    "history": "履歴",
    "long": "ロング",
    "short": "ショート",
    "autoTrading": "自動取引",
    "autoTradingActive": "自動取引アクティブ",
    "autoTradingDisabled": "自動取引無効",
    "autoTradingActiveDesc": "シグナルが自動的に実行されます",
    "autoTradingDisabledDesc": "取引シグナルを自動実行するには有効にしてください",
    "noActiveSignals": "アクティブなシグナルなし",
    "waitingForSignals": "新しい取引機会を待機中...",
    "enableAutoTrading": "シグナルを受信するには自動取引を有効にしてください",
    "refreshSignals": "シグナル更新",
    "noOpenPositions": "オープンポジションなし",
    "positionsDesc": "アクティブな取引ポジションがここに表示されます",
    "noTradingHistory": "取引履歴なし",
    "historyDesc": "完了した取引がここに表示されます",
    "executeTradeButton": "取引実行",
    "viewDetailsButton": "詳細表示",
    "entry": "エントリー",
    "stopLoss": "ストップロス",
    "takeProfit": "テイクプロフィット",
    "confidence": "{{value}}% 信頼度",
    "strategy": "戦略",
    "firstTp": "第1TP",
    "secondTp": "第2TP",
    "autoMoveStopLoss": "第1TP後にSLを損益分岐点に自動移動",
    "tradingMode": "取引モード",
    "paperMode": "デモ",
    "liveMode": "ライブ",
    "paperTradingActive": "デモ取引アクティブ",
    "liveTradingActive": "ライブ取引アクティブ",
    "paperTradingDesc": "仮想資金で取引練習",
    "liveTradingDesc": "実際のお金で取引",
    "virtualBalance": "仮想残高",
    "unrealizedPnL": "未実現損益",
    "equity": "資本",
    "paperTradingHelp": "デモ取引ヘルプ",
    "resetAccount": "アカウントリセット",
    "paperTradingGuide": "デモ取引ガイド",
    "paperModeTitle": "デモモード",
    "noProfitSharePaper": "デモモードでは利益分配なし",
    "paperTradingPositions": "総ポジション:",
    "paperTradingHistory": "デモ取引履歴",
    "simulatedTradingHistory": "シミュレーション取引履歴",
    "noPaperPositions": "デモ取引ポジションなし",
    "enableAutoTradingPaper": "デモ取引は市場シグナルに基づいてシミュレーションポジションを自動生成します",
    "paperTradingMode": "デモ取引モード",
    "autoTradingNotAvailable": "自動取引利用不可",
    "autoTradingDisabledPaper": "自動取引はライブ取引を制御します。デモ取引は自動的にシグナルを生成します。",
    "riskManagement": "リスク管理",
    "riskSettings": "リスク設定",
    "investmentPercentage": "投資割合",
    "leverage": "レバレッジ",
    "maxLeverage": "最大レバレッジ",
    "currentTier": "現在のティア",
    "exchange": "取引所",
    "accountType": "アカウントタイプ",
    "marketType": "市場タイプ",
    "saveSettings": "設定保存",
    "resetToSafe": "安全にリセット",
    "saving": "保存中...",
    "riskSettingsSaved": "リスク設定が正常に保存されました",
    "failedToSaveRiskSettings": "リスク設定の保存に失敗しました",
    "position": "ポジション",
    "internal": "内部",
    "external": "外部",
    "marketClose": "市場終了",
    "reverse": "リバース",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "アクティブポジション更新",
    "youHaveNoPosition": "ポジションがありません。",
    "noActiveAppPositions": "アクティブなアプリポジションが見つかりません。",
    "noActiveExternalPositions": "アクティブな外部ポジションが見つかりません。",
    "yourActivePositionsWillAppear": "アクティブな取引ポジションがここに表示されます。",
    "previous": "前へ",
    "next": "次へ",
    "learnMore": "詳細を見る",
    "paperTradingLabel": "デモ取引",
    "recentPaperTrades": "最近のデモ取引",
    "noPaperTrades": "まだデモ取引がありません",
    "paperTradingAutoGenerate": "デモ取引は市場シグナルに基づいてシミュレーション取引を自動生成します",
    "activePositionsTitle": "アクティブポジション",
    "youHaveNoPositions": "ポジションがありません。",
    "yourActivePositionsWillAppearHere": "取引を開始するか自動取引を有効にすると、アクティブな取引ポジションがここに表示されます。",
    "max": "最大",
    "tooltips": {
      "virtualBalance": "クローズされた取引からの実現残高。計算式：初期残高 + すべてのクローズされた取引からの純損益合計。",
      "unrealizedPnL": "現在オープンしているポジションからの利益または損失。この値は現在の市場価格に基づいてリアルタイムで変化し、まだ実現されていません。",
      "equity": "オープンポジションを含む総口座価値。計算式：仮想残高 + 未実現損益。これはデモ取引における現在の純資産を表します。",
      "profitAndLoss": "クローズされた取引のみからの実現損益。オープンポジションからの未実現損益は含まれません。",
      "balance": "取引に利用可能な現在の口座残高。",
      "pnlToday": "本日クローズされた取引からの実現損益。",
      "monthlyRate": "初期残高のパーセンテージとして計算された月次リターン率。",
      "winRate": "利益を上げたクローズされた取引のパーセンテージ。完了した取引のみから計算されます。",
      "totalReturn": "仮想残高に基づく総リターン率。計算式：(現在の仮想残高 - 初期残高) / 初期残高 × 100%。"
    }
  },
  "common": {
    "loading": "読み込み中...",
    "error": "エラー",
    "success": "成功",
    "save": "保存",
    "cancel": "キャンセル",
    "yes": "はい",
    "no": "いいえ",
    "active": "アクティブ",
    "inactive": "非アクティブ",
    "on": "オン",
    "off": "オフ",
    "enabled": "有効",
    "disabled": "無効",
    "for": "の",
    "warning": "Warning",
    "info": "情報",
    "confirm": "確認",
    "edit": "Edit",
    "delete": "Delete",
    "close": "閉じる",
    "back": "戻る",
    "next": "次へ",
    "previous": "前へ",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "有効化",
    "disable": "無効化",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "OK",
    "apply": "適用",
    "clear": "クリア",
    "select": "選択",
    "upload": "アップロード",
    "download": "ダウンロード",
    "copy": "コピー",
    "copied": "コピーしました！",
    "share": "Share",
    "print": "印刷",
    "export": "Export",
    "import": "Import",
    "and": "と",  },
  "wallet": {
    "connect": "ウォレット接続",
    "disconnect": "切断",
    "connected": "接続済み",
    "notConnected": "未接続",
    "connecting": "接続中...",
    "balance": "残高",
    "address": "アドレス",
    "solanaBlockchain": "Solanaブロックチェーン搭載",
    "solanaTooltip": "Solana上に構築 - 高速、安全、スケーラブルなブロックチェーン",
    "wrongNetwork": "間違ったネットワーク",
    "switchNetwork": "ネットワーク切り替え",
    "transactionPending": "取引保留中",
    "transactionConfirmed": "取引確認済み",
    "transactionFailed": "取引失敗",
    "connectionError": "接続エラー",
    "connectionFailed": "ウォレット接続に失敗しました",
    "connectionRejected": "ウォレット接続が拒否されました",
    "walletNotFound": "Solanaウォレットが見つかりません。Phantomなどのウォレットをインストールしてください。",
    "disconnected": "ウォレット切断済み",
    "disconnectedSuccess": "ウォレットが正常に切断されました。",
    "disconnectError": "切断エラー",
    "disconnectFailed": "ウォレットの切断に失敗しました。",
    "confirmDisconnect": "ウォレット切断の確認",
    "confirmDisconnectMessage": "本当にウォレットを切断しますか？",
  },
  "notifications": {
    "autoTradingEnabled": "自動取引が有効になりました",
    "autoTradingDisabled": "自動取引が無効になりました",
    "settingsSaved": "設定が正常に保存されました",
    "passwordChanged": "パスワードが正常に変更されました",
    "profileUpdated": "プロフィールが正常に更新されました",
    "walletConnected": "ウォレットが正常に接続されました",
    "walletDisconnected": "ウォレットが切断されました",
    "signalExecuted": "取引シグナルが実行されました",
    "tradeCompleted": "取引が正常に完了しました",
    "paymentSuccessful": "支払いが正常に処理されました",
    "tierUpgraded": "ティアが正常にアップグレードされました",
    "autoTrading": {
      "enabledTitle": "自動取引が有効になりました",
      "enabledDescription": "自動取引が正常に有効になりました。残高要件が確認されました。",
      "disabledTitle": "自動取引が無効になりました",
      "disabledDescription": "自動取引が正常に無効になりました。",
      "insufficientBalanceTitle": "残高不足",
      "insufficientBalanceDescription": "最低{{required}} USDTの残高が必要です。現在の残高は{{current}} USDTです。",
      "missingCredentialsTitle": "API認証情報が不足",
      "missingCredentialsDescription": "まず取引所のAPI認証情報を追加して検証してください。",
      "balanceVerificationFailedTitle": "残高確認に失敗",
      "balanceVerificationFailedDescription": "アカウント残高の確認に失敗しました。API認証情報を確認してください。",
      "errorTitle": "自動取引エラー",
      "errorDescription": "自動取引の切り替えに失敗しました。もう一度お試しください。",
      "systemDisabledTitle": "自動取引が無効になりました",
      "noApiCredentialsReason": "取引所のAPI認証情報が設定されていません。APIキーを追加してください。",
      "investmentPercentageReason": "投資割合が0%に設定されています。リスク設定を調整してください。",
    },
    "paperAutoTrading": {
      "enabledTitle": "ペーパー自動取引が有効になりました",
      "enabledDescription": "ペーパー取引シグナルが自動的に実行されるようになりました",
      "disabledTitle": "ペーパー自動取引が無効になりました",
      "disabledDescription": "ペーパー取引シグナルは自動的に実行されなくなりました",
      "errorTitle": "ペーパー自動取引エラー",
      "errorDescription": "ペーパー自動取引の切り替えに失敗しました"
    }
  },
  "errors": {
    "generic": "何かが間違っています。もう一度お試しください。",
    "network": "ネットワークエラー。接続を確認してください。",
    "unauthorized": "この操作を実行する権限がありません。",
    "forbidden": "アクセスが拒否されました。",
    "notFound": "要求されたリソースが見つかりませんでした。",
    "serverError": "サーバーエラー。後でもう一度お試しください。",
    "validationError": "入力を確認してもう一度お試しください。",
    "walletNotConnected": "最初にウォレットを接続してください。",
    "insufficientBalance": "残高不足です。",
    "transactionFailed": "取引が失敗しました。もう一度お試しください。",
    "apiError": "APIエラー。これが続く場合はサポートにお問い合わせください。",
  },
  "settings": {
    "title": "アカウント設定",
    "pleaseLogIn": "ログインしてください",
    "loginRequired": "アカウント設定にアクセスするにはログインが必要です。",
    "goToLogin": "ログインへ",
    "profile": {
      "title": "プロフィール設定",
      "description": "アカウント情報と設定を管理",
      "email": "メールアドレス",
      "currentEmail": "現在のメール",
      "newEmail": "新しいメールアドレス",
      "updateEmail": "メール更新",
      "sending": "送信中...",
      "placeholders": {
        "newEmail": "新しいメールアドレスを入力してください",
        "currentPassword": "現在のパスワードを入力してください"
      }
    },
    "security": {
      "title": "セキュリティ設定",
      "description": "パスワードとセキュリティ設定を管理",
      "changePassword": "パスワード変更",
      "currentPassword": "現在のパスワード",
      "newPassword": "新しいパスワード",
      "confirmPassword": "新しいパスワードの確認",
      "enable2FA": "二要素認証",
      "twoFactorEnabled": "アカウントで二要素認証が有効になっています",
      "twoFactorDisabled": "アカウントで二要素認証が無効になっています",
      "changing": "変更中...",
      "changePasswordButton": "パスワード変更",
      "verificationCode": "認証コード",
      "verifyCode": "コード確認",
      "verifying": "確認中...",
      "cancel": "キャンセル",
      "disable2FA": "二要素認証を無効にする",
      "disable2FADescription": "本当に2FAを無効にしますか？これによりアカウントのセキュリティが低下します。この操作を確認するため、メールに認証コードを送信します。",
      "sendVerificationCode": "認証コードを送信",
      "disabling": "無効化中...",
      "disable2FAButton": "2FAを無効にする",
      "resendCode": "コードを再送信",
      "verifyEmail": "メールを確認",
      "verifyEmailDescription": "メールに6桁の認証コードを送信しました。2FAを有効にするため、以下に入力してください。",
      "verifyEmailToDisable2FA": "2FA無効化のためのメール確認",
      "verifyEmailToDisable2FADescription": "メールに6桁の認証コードを送信しました。二要素認証を無効にするため、以下に入力してください。",
      "placeholders": {
        "currentPassword": "現在のパスワードを入力してください",
        "newPassword": "新しいパスワードを入力してください",
        "confirmPassword": "新しいパスワードを確認してください",
        "verificationCode": "6桁のコードを入力してください"
      }
    },
    "account": {
      "title": "危険ゾーン",
      "deleteAccount": "アカウント削除",
      "deleteAccountWarning": "アカウントを削除すると元に戻せません。慎重に決定してください。",
      "deleteAccountButton": "アカウント削除",
      "deleting": "削除中...",
      "deleteAccountModal": {
        "title": "アカウント削除",
        "description": "この操作は元に戻せません。アカウントが完全に削除され、関連するすべてのデータが削除されます。",
        "confirmText": "アカウント削除",
        "typedConfirmationText": "削除",
        "permanentlyDelete": "以下が完全に削除されます：",
        "consequences": [
          "すべてのデータを完全に削除",
          "取引履歴を削除",
          "アクティブなサブスクリプションをキャンセル",
          "すべてのAPI認証情報を削除",
          "すべての設定と設定を削除"
        ]
      }
    },
    "errors": {
      "fillAllFields": "すべてのフィールドを入力してください",
      "passwordsNotMatch": "新しいパスワードが一致しません",
      "invalidVerificationCode": "認証コードを入力してください",
      "invalid6DigitCode": "有効な6桁の認証コードを入力してください",
      "updateEmailFailed": "メール更新に失敗しました",
      "changePasswordFailed": "パスワード変更に失敗しました",
      "enable2FAFailed": "2FA有効化に失敗しました",
      "verify2FAFailed": "2FAコード確認に失敗しました",
      "disable2FAFailed": "無効化認証コード送信に失敗しました",
      "disable2FAVerifyFailed": "2FA無効化に失敗しました",
      "deleteAccountFailed": "アカウント削除に失敗しました"
    },
    "success": {
      "verificationEmailSent": "認証メール送信済み",
      "verificationEmailDescription": "認証手順について{{email}}を確認してください。",
      "passwordChanged": "パスワード変更済み",
      "passwordChangedDescription": "パスワードが正常に更新されました。",
      "2FACodeSent": "2FAコード送信済み",
      "2FACodeSentDescription": "認証コードについてメールを確認してください。",
      "2FAEnabled": "2FA有効化済み",
      "2FAEnabledDescription": "二要素認証が正常に有効化されました。",
      "verificationCodeSent": "認証コード送信済み",
      "verificationCodeSentDescription": "2FA無効化のための6桁認証コードについてメールを確認してください。",
      "2FADisabled": "2FA無効化済み",
      "2FADisabledDescription": "二要素認証が正常に無効化されました。",
      "accountDeleted": "アカウント削除済み",
      "accountDeletedDescription": "アカウントが正常に削除されました。"
    }
  },
  "accessSecurity": {
    "title": "アクセスとセキュリティ",
    "subtitle": "アカウントのセキュリティとログイン活動を監視",
    "totalLogins": "総ログイン数",
    "successRate": "成功率",
    "uniqueIPs": "ユニークIP",
    "twoFactorStatus": "2FA状態",
    "enabled": "有効",
    "disabled": "無効",
    "currentSession": "現在のセッション",
    "currentSessionDescription": "現在のログインセッションに関する情報",
    "recentLoginActivity": "最近のログイン活動",
    "recentLoginDescription": "最近のログイン試行とセッション",
    "refresh": "更新",
    "ipAddress": "IPアドレス",
    "timestamp": "タイムスタンプ",
    "status": "ステータス",
    "userAgent": "ユーザーエージェント",
    "successful": "成功",
    "failed": "失敗",
    "noLoginActivity": "ログイン活動が見つかりません",
    "currentDevice": "現在のデバイス",
    "location": "場所",
    "sessionStart": "セッション開始",
    "lastLoginActivity": "最後のログイン活動",
    "lastLoginDescription": "最後の成功したログイン",
    "loginTime": "ログイン時間",
    "browser": "ブラウザ",
    "lastThirtyDays": "過去30日間",
    "loginSuccessRate": "ログイン成功率",
    "differentLocations": "異なる場所",
    "never": "なし",
    "unknown": "不明",
    "reason": "理由:",
    "authenticationRequired": "認証が必要",
    "authenticationRequiredDescription": "セキュリティ情報を表示するにはログインしてください。",
    "errors": {
      "authenticationError": "認証エラー",
      "authenticationErrorDescription": "セキュリティデータを表示するには再度ログインしてください。",
      "networkError": "ネットワークエラー",
      "networkErrorDescription": "セキュリティデータの取得に失敗しました。接続を確認してください。",
      "refreshFailed": "更新に失敗",
      "refreshFailedDescription": "セキュリティデータの更新に失敗しました。再度お試しください。"
    },
    "success": {
      "dataRefreshed": "セキュリティデータが更新されました",
      "dataRefreshedDescription": "セキュリティ情報が正常に更新されました。"
    }
  },
  "tiers": {
    "title": "ティア管理",
    "currentTier": "現在のティア",
    "choosePlan": "プランを選択",
    "tier1": {
      "name": "ティア1",
      "subtitle": "無料",
      "description": "基本的な取引シグナルで始めるのに最適",
      "features": [
        "基本的な取引シグナル",
        "手動取引実行",
        "コミュニティサポート",
        "基本的な市場分析"
      ]
    },
    "tier2": {
      "name": "ティア2",
      "subtitle": "30日間アクセス",
      "description": "本格的なトレーダー向けの高度な機能",
      "features": [
        "高度なAI取引シグナル",
        "自動取引機能",
        "優先サポート",
        "高度な分析",
        "リスク管理ツール"
      ]
    },
    "tier3": {
      "name": "ティア3",
      "subtitle": "NFT必須",
      "description": "独占機能付きプレミアムティア",
      "features": [
        "プレミアム取引シグナル",
        "高度な自動取引",
        "VIPサポート",
        "独占的な市場インサイト",
        "カスタム戦略"
      ]
    },
    "activate": "アクティベート",
    "current": "現在",
    "paymentRequired": "支払い必須",
    "nftRequired": "NFT必須",
    "membershipStatus": "メンバーシップステータス",
    "active": "アクティブ",
    "expired": "期限切れ",
    "daysRemaining": "残り日数",
    "expiresOn": "期限",
  },
  "apiCredentials": {
    "title": "API認証情報",
    "description": "取引用の取引所API認証情報を管理",
    "addCredentials": "API認証情報を追加",
    "exchange": "取引所",
    "exchanger": "取引所",
    "apiKey": "APIキー",
    "apiSecret": "APIシークレット",
    "secretKey": "シークレットキー",
    "passphrase": "パスフレーズ",
    "testConnection": "接続テスト",
    "save": "認証情報を保存",
    "edit": "編集",
    "delete": "削除",
    "status": "ステータス",
    "connected": "接続済み",
    "disconnected": "切断済み",
    "invalid": "無効",
    "active": "アクティブ",
    "testing": "テスト中...",
    "connectionSuccess": "接続成功",
    "connectionFailed": "接続失敗",
    "credentialsAdded": "API認証情報が正常に追加されました",
    "credentialsUpdated": "API認証情報が正常に更新されました",
    "credentialsDeleted": "API認証情報が正常に削除されました",
    "credentialAddedLimitReached": "認証情報追加済み（上限到達）",
    "requiredMarketType": "必要な市場タイプ",
    "connectedTo": "接続先：",
    "connectionNeedsAttention": "接続が必要：",
    "needsAttention": "注意が必要",
    "lastUpdated": "最終更新",
    "updateCredentialsMessage": "取引を続行するにはAPI認証情報を更新してください",
    "disconnect": "切断",
    "disconnecting": "切断中...",
    "setAsActive": "アクティブに設定",
    "activating": "アクティブ化中...",
    "autoTrading": "自動取引",
    "enableAutoTradingDesc": "この取引所で自動取引を有効にする",
    "tier2LimitReached": "ティア2制限に到達：最大2つのCEX認証情報が許可されています。",
    "add": "追加",
    "update": "更新",
    "connectionValidated": "接続が検証されました！",
    "autoTradingStatusChanged": "自動取引が",
    "marketTypes": {
      "futures": "先物",
      "spot": "現物",
      "binanceNote": "先物取引 - 最大125倍のレバレッジが利用可能",
      "binanceUsNote": "マージン付き現物取引 - 最大3倍のレバレッジが利用可能",
      "krakenNote": "先物取引 - 最大100倍のレバレッジが利用可能",
      "bybitNote": "先物取引 - 最大100倍のレバレッジが利用可能",
      "hyperliquidNote": "無期限先物取引 - 最大50倍のレバレッジが利用可能",
      "standardNote": "標準現物取引",
    },
    "errors": {
      "loadFailed": "認証情報の読み込みに失敗しました",
      "keysRequired": "APIキーとシークレットキーが必要です",
      "tierUndetermined": "ユーザーティアを確認できません",
      "tier1Limit": "ティア1では1つのAPI認証情報のみ許可されています",
      "tier2PerCex": "ティア2ではCEXごとに1つの認証情報のみ許可されています",
      "tier2Limit": "ティア2では最大2つの認証情報が許可されています（CEXごとに1つ）",
      "tier3Limit": "ティア3では全てのCEXに対して1つの認証情報のみ許可されています",
      "saveFailed": "保存に失敗しました",
      "validationFailed": "検証に失敗しました",
      "activationFailed": "アクティブ化に失敗しました",
      "deactivationFailed": "非アクティブ化に失敗しました",
      "noCredentials": "この取引所の認証情報が見つかりません",
      "autoTradingUpdateFailed": "自動取引の更新に失敗しました",
      "autoTradingUpdateFailedDesc": "自動取引設定の更新に失敗しました",
    },
    "success": {
      "credentialsSaved": "認証情報が保存されました",
      "connectionSuccessful": "接続成功",
      "activated": "アクティブ化されました",
      "deactivated": "非アクティブ化されました",
      "autoTradingEnabled": "自動取引が有効になりました",
      "autoTradingDisabled": "自動取引が無効になりました",
    }
  },
  "referrals": {
    "title": "紹介ダッシュボード",
    "loading": "紹介ダッシュボードを読み込み中...",
    "referralLink": "紹介リンク",
    "referralLinkDescription": "このリンクを共有して、紹介者の利益分配支払いから{{rate}}%を獲得しましょう。",
    "tierNames": {
      "tier1": "ティア1",
      "tier2": "ティア2",
      "tier3": "ティア3"
    },
    "settings": {
      "title": "設定",
      "referralSettings": "紹介設定",
      "solanaWalletAddress": "Solanaウォレットアドレス",
      "walletPlaceholder": "支払い用のSolanaウォレットアドレスを入力してください",
      "minimumPayoutAmount": "最小支払額 ($)",
      "enableAutomaticPayments": "自動支払いを有効にする",
      "autoPaymentEnabled": "有効にすると、紹介支払いが期限になったときに自動的に受け取ります。",
      "autoPaymentDisabled": "無効にすると、これが再び有効になるまで紹介支払いを受け取りません。",
      "saveSettings": "設定を保存",
      "importantWarning": "重要な警告:",
      "warnings": {
        "ensureCorrectAddress": "Solanaウォレットアドレスが正しいことを確認してください",
        "doubleCheckAddress": "保存前にアドレスを再確認してください",
        "notResponsible": "DeepTradeは間違ったまたは無効なアドレスに送信された支払いについて責任を負いません",
        "cannotRecover": "間違ったアドレスによる資金の損失は回復できません"
      },
      "minimumPayoutRequirements": "最小支払い要件:",
      "requirements": {
        "minimumAmount": "最小支払額: $10.00 USDT",
        "gasFeeDeducted": "Solanaネットワークのガス手数料が支払いから差し引かれます",
        "estimatedGasFee": "推定ガス手数料: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "支払いはSolanaネットワーク上でUSDTで処理されます"
      }
    },
    "overview": {
      "totalReferrals": "総紹介数",
      "activeCount": "{{count}}名アクティブ",
      "totalEarnings": "総収益",
      "totalPaid": "${{amount}}支払済み",
      "pendingPayout": "保留中の支払い",
      "requestPayout": "支払いを要求",
      "earningRate": "収益率"
    },
    "actions": {
      "copy": "コピー",
      "generateNew": "新規生成"
    },
    "recentActivity": {
      "recentReferrals": "最近の紹介",
      "recentEarnings": "最近の収益",
      "noReferrals": "まだ紹介がありません。リンクの共有を始めましょう！",
      "noEarnings": "まだ収益がありません。紹介者が取引を開始する必要があります！",
      "earned": "${{amount}}獲得"
    },
    "status": {
      "verified": "確認済み",
      "pending": "保留中",
      "paid": "支払済み"
    },
    "messages": {
      "copied": "コピーしました！",
      "linkCopied": "紹介リンクがクリップボードにコピーされました",
      "newCodeGenerated": "新しい紹介コードが生成されました",
      "profileUpdated": "プロフィールが正常に更新されました",
      "payoutRequestSubmitted": "支払い要求が送信されました"
    },
    "errors": {
      "failedToLoadData": "紹介データの読み込みに失敗しました",
      "failedToGenerateCode": "新しいコードの生成に失敗しました",
      "invalidMinimumPayout": "無効な最小支払額",
      "minimumPayoutRequired": "最小支払額は少なくとも$10.00である必要があります",
      "invalidWalletAddress": "無効なウォレットアドレス",
      "validWalletRequired": "有効なSolanaウォレットアドレスを入力してください",
      "failedToUpdateProfile": "プロフィールの更新に失敗しました",
      "failedToRequestPayout": "支払い要求に失敗しました"
    }
  },

  "paperTradingHelp": {
    "title": "デモ取引ガイド",
    "whatIsPaperTrading": "デモ取引とは？",
    "whatIsPaperTradingDesc": "デモ取引は、実際の資金の代わりに仮想マネーを使用して取引戦略を練習できるシミュレーション取引環境です。金融リスクなしでAI取引システムをテストする完璧な方法です。",
    "keyBenefits": "主な利点",
    "riskFree": "リスクフリー学習",
    "riskFreeDesc": "仮想資金で練習 - 実際のお金のリスクなし",
    "realMarketData": "リアル市場データ",
    "realMarketDataDesc": "ライブ市場状況と価格変動を体験",
    "aiTradingSystem": "AI取引システム",
    "aiTradingSystemDesc": "安全な環境で高度なAIシグナルをテスト",
    "buildConfidence": "自信を構築",
    "buildConfidenceDesc": "実際のお金を使用する前に取引スキルを開発",
    "howItWorks": "仕組み",
    "step1": "デモモードに切り替え",
    "step1Desc": "取引モードトグルを切り替えてデモ取引を有効化",
    "step2": "仮想残高",
    "step2Desc": "$10,000の仮想残高でスタート（リセット可能）",
    "step3": "AIシグナル",
    "step3Desc": "AIがリアル市場データに基づいて取引シグナルを生成",
    "step4": "シミュレーション取引",
    "step4Desc": "取引が仮想的に実行される - パフォーマンスを追跡",
    "importantNotes": "重要な注意事項",
    "noRealMoney": "実際のお金なし",
    "noRealMoneyDesc": "デモ取引は仮想資金のみを使用します。実際の利益や損失は発生しません。",
    "noRealFees": "実際の手数料なし",
    "noRealFeesDesc": "取引手数料とスリッページは現実的な体験のためにシミュレーションされます。",
    "performanceTracking": "パフォーマンス追跡",
    "performanceTrackingDesc": "すべての統計と分析はシミュレーション取引のみに基づいています。",
    "readyToStart": "始める準備はできましたか？",
    "readyToStartDesc": "「取引モード」スイッチを「デモ」に切り替えて、今日から仮想資金で練習を始めましょう！",
    "buildConfidenceFooter": "💪 実際のお金をリスクにさらす前にデモ取引で自信を築きましょう！",
    "resetModal": {
      "title": "デモ取引アカウントリセット",
      "warning": "警告：この操作は元に戻せません",
      "warningDesc": "すべてのデモ取引履歴が永続的に削除され、仮想残高がリセットされます。",
      "resetLimitReached": "1日のリセット制限に達しました",
      "resetLimitReachedDesc": "今日の3回のリセットをすべて使用しました。制限はUTC午前0時にリセットされます。",
      "resetsRemaining": "今日の残りリセット回数：{{count},",
      "currentBalance": "現在の残高：${{balance},",
      "resetToDefault": "デフォルトの$10,000にリセット",
      "customBalance": "カスタム残高を設定",
      "customBalanceDesc": "カスタム開始残高を入力（最小$1,000）",
      "confirmationRequired": "'RESET'と入力して確認",
      "confirmationPlaceholder": "ここにRESETと入力...",
      "confirmationRequiredError": "確認するには'RESET'と入力してください",
      "invalidBalance": "無効な残高",
      "invalidBalanceDesc": "有効な正の残高金額を入力してください",
      "resetting": "リセット中...",
      "resetButton": "アカウントリセット",
    },
    "howItWorksModal": {
      "title": "デモ取引の仕組み",
      "step1": "$10,000の仮想残高でスタート（設定可能）",
      "step2": "AIが自動的に取引を実行するように自動取引を有効化",
      "step3": "パフォーマンスを監視し、必要に応じてリスク設定を調整",
      "step4": "システムに自信が持てたらライブ取引に切り替え",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "実際のお金なし：",
      "noRealMoneyDesc": "デモ取引は仮想資金のみを使用します。実際の利益や損失は発生しません。",
      "noFeesTitle": "手数料なし：",
      "noFeesDesc": "デモ取引では実際の利益が発生しないため、利益分配手数料は発生しません。",
      "resetLimitTitle": "リセット制限：",
      "resetLimitDesc": "デモアカウントは1日最大3回までリセットできます。",
    },
    "benefits": {
      "title": "デモ取引の利点",
      "riskFreeLearning": "リスクフリー学習",
      "riskFreeLearningDesc": "AIシステムの仕組みを学びながら、実際のお金を失うことなく練習できます",
      "strategyTesting": "戦略テスト",
      "strategyTestingDesc": "異なるリスク設定をテストし、時間の経過とともにどのように機能するかを確認できます",
      "realMarketData": "実際の市場データ",
      "realMarketDataDesc": "本格的な体験のために、ライブ市場価格と実際のML予測を使用します",
    },
    "gettingStarted": {
      "title": "始める準備はできましたか？",
      "description": "「取引モード」スイッチを「デモ」に切り替えて、今日から仮想資金で練習を始めましょう！",
      "buildConfidenceFooter": "💪 実際のお金をリスクにさらす前に、デモ取引で自信をつけましょう！",
    },
    "perfectForBeginners": "💡 新しい戦略をテストしたい初心者と経験豊富なトレーダーに最適です！",
    "availableToAllTitle": "すべてのユーザーが利用可能:",
    "availableToAllDesc": "デモ取引は、ティアレベルに関係なくすべてのユーザーが利用できます。",
    "gotItThanks": "わかりました、ありがとうございます！",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "デモ取引パフォーマンス",
      "refresh": "更新",
      "reset": "リセット",
      "totalReturn": "総リターン",
    },

    "errors": {
      "loadFailed": "デモ取引データの読み込みに失敗しました",
    }
  },
  "tradingSignalStatus": {
    "title": "取引シグナルステータス",
    "description": "システム全体のシグナルブロードキャストからのライブステータス",
    "signalLabel": "シグナル",
    "confidenceLabel": "AIシグナル信頼度",
    "lastUpdateLabel": "最終更新",
    "errorLoading": "取引ステータスの読み込みに失敗しました",
    "signals": {
      "HOLD": "ホールド",
      "BUY": "買い",
      "SELL": "売り",
      "LONG": "ロング",
      "SHORT": "ショート",
      "long": "ロング",
      "short": "ショート"
    }
  },
  "pagination": {
    "show": "表示",
    "perPage": "件/ページ",
    "showing": "{{total}}件中{{start}}〜{{end}}件を表示",
    "previous": "前へ",
    "next": "次へ"
  },
  "tier": {
    "choosePlan": "プランを選択",
    "membershipStatus": {
      "title": "メンバーシップステータス",
      "active": "アクティブ",
      "expired": "期限切れ",
      "daysRemaining": "残り日数:",
      "expiresOn": "有効期限:"
    },
    "modals": {
      "activateTier": "{{tierName}}ティアを有効化",
      "confirmActivation": "{{tierName}}ティアを有効化してもよろしいですか？",
      "confirmTierChange": "ティア変更の確認",
      "confirmSwitch": "{{tierName}}ティアに変更してもよろしいですか？",
      "cancel": "キャンセル",
      "activate": "有効化",
      "confirm": "確認"
    },
    "tiers": {
      "starter": {
        "name": "ティア1: スターター",
        "price": "無料",
        "description": "始めるのに最適",
        "features": [
          "基本的なトレーディングシグナル",
          "最大2.5倍のトレーディングレバレッジ",
          "1つのAPIアクセスに制限",
          "40%の利益分配手数料"
        ]
      },
      "pro": {
        "name": "ティア2: プロ",
        "description": "本格的なトレーダー向け",
        "accessInstructions": "このティアにアクセスするには、上部ナビゲーションバーのウォレットボタンを使用してSolanaウォレットを接続し、30日間のアクセス料金をお支払いください。",
        "features": [
          "高度なトレーディングシグナル",
          "最大5倍のトレーディングレバレッジ",
          "2つのAPIアクセスに制限",
          "20%の利益分配手数料"
        ]
      },
      "nftElite": {
        "name": "ティア3: NFTエリート",
        "price": "生涯",
        "description": "認証されたCapitolchilax NFTコレクター向け。",
        "visitWebsite": "capitolchilax.comを訪問",
        "accessInstructions": "このティアにアクセスするには、上部ナビゲーションバーのウォレットボタンを使用して接続し、NFTの資格を確認してください。",
        "features": [
          "高度なトレーディングシグナル",
          "最大10倍のトレーディングレバレッジ",
          "無制限のAPI接続",
          "10%の利益分配手数料",
          "月額メンバーシップ料金なし"
        ]
      }
    },
    "status": {
      "currentTier": "現在のティア",
      "alreadyUnlocked": "既にアンロック済み",
      "yourCurrentTier": "あなたの現在のティア",
      "currentlyOn": "現在{{tierName}}をご利用中です"
    },
    "buttons": {
      "paymentRequired": "支払いが必要",
      "connectWallet": "ウォレットを接続",
      "nftRequired": "NFTが必要",
      "select": "{{tierName}}を選択",
      "activate": "{{tierName}}を有効化",
      "payWithToken": "{{token}}で支払う",
      "payToReactivate": "支払って再有効化",
      "connectWalletFirst": "最初にウォレットを接続",
      "proceedWithPayment": "支払いを続行"
    },
    "pricing": {
      "free": "無料",
      "lifetime": "生涯",
      "thirtyDayAccess": "30日間アクセス: {{price}}"
    },
    "profitShare": {
      "status": "利益分配ステータス",
      "paymentDue": "支払い期限",
      "accountDisabled": "アカウント無効",
      "accountTradingDisabled": "アカウントトレーディング無効",
      "accountDisabledDescription": "未払いの利益分配手数料${{amount}}のため、アカウントが無効になっています。",
      "deadlineApproaching": "期限が近づいています",
      "deadlineMessage": "利益分配の支払い${{amount}}の期限が近づいています。",
      "deadline": "期限:",
      "payNow": "今すぐ支払う",
      "youOwe": "お支払い額: {{amount}}",
      "allCaughtUp": "すべて完了しています！",
      "accountSuspendedWarning": "アカウントが一時停止されています。取引を再開するには支払いを完了してください。",
      "disabledOn": "無効化日:",
      "paymentWasDue": "支払い期限でした:",
      "nextPaymentDeadline": "次回支払い期限:",
      "scheduleInfo": "利益分配の支払いは毎週土曜日0:00 GMTが期限です",
      "disableWarning": "アカウントは未払い手数料のため毎週土曜日0:00 GMTに無効化されます",
      "accountDisabledMessage": "アカウントが無効化されています。取引を再開するには支払いを完了してください。",
      "paymentOverdue": "支払いが延滞しています",
      "paymentDueSoon": "支払い期限が近づいています",
      "wasDue": "期限でした:",
      "due": "期限:",
      "overdue": "延滞",
      "noPendingFees": "未払いの利益分配手数料はありません - すべて完了しています！🎉"
    },
    "payment": {
      "thirtyDaysAccess": "30日間アクセス",
      "thirtyDaysAccessDescription": "30日間のプレミアムアクセスの支払いが必要です",
      "thirtyDaysAccessDue": "30日間アクセス料金の支払い期限",
      "paymentDetails": "支払い詳細",
      "amount": "金額",
      "network": "ネットワーク",
      "wallet": "ウォレット",
      "connectionStatus": "接続ステータス",
      "connected": "接続済み",
      "disconnected": "未接続",
      "importantNotes": "重要な注意事項",
      "paymentWarnings": [
        "{{token}}トークンのみが受け付けられます",
        "支払いは返金不可です",
        "取引が確認されるまでお待ちください",
        "支払い後、アクセスが自動的に有効化されます"
      ],
      "processing": "処理中",
      "processingDescription": "支払いを処理しています。しばらくお待ちください...",
      "successful": "成功",
      "successDescription": "支払いが正常に処理されました！",
      "failed": "失敗",
      "failedDescription": "支払いの処理中にエラーが発生しました。もう一度お試しください。",
      "tryAgain": "再試行"
    },
    "paymentHistory": {
      "title": "支払い履歴",
      "profitShare": "利益分配",
      "thirtyDaysAccess": "30日間アクセス",
      "billingPeriod": "${{amount}} - {{startDate}}から{{endDate}}まで"
    },
    "nft": {
      "verifyingOwnership": "NFT所有権を確認中...",
      "nftRequired": "このティアにはNFTが必要です",
      "nftOwned": "NFTが確認されました ✓"
    },
    "coupon": {
      "haveACoupon": "クーポンをお持ちですか？こちらで引き換え",
      "upgradeInstantly": "クーポンコードでティアを即座にアップグレード",
      "redeemButton": "クーポンを使用",
      "redeemDescription": "クーポンコードでティアを即座にアップグレード"
    },
    "errors": {
      "paymentRequired": "支払いが必要です。未払い額: {{amount}}",
      "activationFailed": "有効化に失敗しました",
      "membershipExpiredTitle": "メンバーシップが期限切れ",
      "membershipExpired": "メンバーシップが期限切れになりました。ティア1に戻されました。",
      "walletDisconnectedTitle": "ウォレットが切断されました",
      "walletDisconnectedWithDays": "ウォレットが切断されましたが、メンバーシップはあと{{days}}日有効です。",
      "couldNotValidate": "メンバーシップを検証できませんでした。現在のティアを維持します。",
      "walletDisconnected": "ウォレットが切断されました。",
      "downgradeNotAllowedTitle": "ダウングレードは許可されていません",
      "downgradeNotAllowed": "ティア{{currentTier}}からティア{{newTier}}へのダウングレードはできません。",
      "walletConnectionRequiredTitle": "ウォレット接続が必要",
      "walletConnectionRequired": "このティアにアクセスするにはSolanaウォレットの接続が必要です。",
      "nftRequired": "このティアにはNFTが必要です。",
      "failedToFetchTier": "ティア情報の取得に失敗",
      "errorLoadingTier": "ティア読み込みエラー",
      "walletNotConnectedTitle": "ウォレットが接続されていません",
      "walletNotConnected": "支払いを行うにはウォレットを接続してください。",
      "dataFetchErrorTitle": "データ取得エラー",
      "dataFetchError": "データの取得中にエラーが発生しました: {{error}}"
    },
    "success": {
      "tierUpdated": "ティアが{{tierName}}に更新されました",
      "tierActivated": "ティアが正常に有効化されました",
      "paymentSuccessful": "{{type}}の支払いが正常に完了しました"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 アカウントが無効化されました",
        "description": "未払いの利益分配手数料${{amount}}のため、アカウントが無効化されています。取引を再開するには支払いを完了してください。"
      },
      "paymentOverdue": {
        "title": "⚠️ 支払いが延滞しています",
        "description": "利益分配の支払い${{amount}}が延滞しています。アカウントの無効化を避けるため、すぐに支払いを完了してください。"
      },
      "paymentReminder": {
        "title": "⏰ 支払いリマインダー",
        "description": "利益分配の支払い${{amount}}が土曜日0:00 GMTに期限となります。アカウントの停止を避けるため、お支払いください。"
      }
    }
  },
  "help": {
    "title": "ヘルプ＆サポート",
    "description": "よくある質問への回答を見つけ、法的ポリシーを確認し、サポートチームにお問い合わせください。",
    "faqTab": "よくある質問",
    "legalTab": "法的事項",
    "contactTab": "お問い合わせ",
    "faqSection": {
      "categories": {
        "general": "一般",
        "trading": "取引",
        "tiers": "ティア",
        "setup": "設定",
        "security": "セキュリティ",
        "billing": "請求"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "DeepTradeとは何ですか？",
          "answer": "DeepTradeは、高度な機械学習アルゴリズムを使用して自動取引シグナルとポートフォリオ管理ツールを提供するAI搭載の暗号通貨取引プラットフォームです。"
        },
        "howSignalsWork": {
          "question": "取引シグナルはどのように機能しますか？",
          "answer": "私たちのAIはリアルタイムで市場データを分析し、エントリーポイント、ストップロス、テイクプロフィットレベルを含む売買シグナルを生成します。手動で実行するか、自動取引を有効にできます。"
        },
        "tierLevels": {
          "question": "異なるティアレベルとは何ですか？",
          "answer": "ティア1（無料）：基本シグナル。ティア2（$50/月）：高度なシグナル + 自動取引。ティア3（NFT必要）：プレミアム機能 + 優先サポート。"
        },
        "connectExchange": {
          "question": "取引所アカウントを接続するにはどうすればよいですか？",
          "answer": "ダッシュボードのAPI認証情報に移動し、取引所のAPIキーを追加し（読み取り専用推奨）、システムが接続を検証します。"
        },
        "dataSecure": {
          "question": "私のデータは安全ですか？",
          "answer": "はい、業界標準の暗号化を使用し、秘密鍵を保存することはなく、最大のセキュリティのために読み取り専用APIアクセスを推奨しています。"
        },
        "profitShares": {
          "question": "利益分配はどのように機能しますか？",
          "answer": "ティア2+ユーザーの場合、シグナルを通じて生成された利益の小さな割合を請求します。これにより、私たちの利益があなたの成功と一致します。"
        },
        "cancelSubscription": {
          "question": "いつでもサブスクリプションをキャンセルできますか？",
          "answer": "はい、いつでもサブスクリプションをダウングレードまたはキャンセルできます。現在の請求期間の終了まで、アクセスを維持できます。"
        },
        "supportedExchanges": {
          "question": "サポートされている取引所は何ですか？",
          "answer": "現在、Binance、Coinbase Pro、Krakenなどの主要な取引所をサポートしています。完全なリストについては、API認証情報ページをご確認ください。"
        }
      }
    },
    "legal": {
      "documents": "法的文書",
      "englishNotice": "法的明確性のため、常に英語で表示されます",
      "privacy": {
        "title": "プライバシーポリシー",
        "description": "プライバシーポリシーは、DeepTradeのサービスを使用する際に個人情報を収集、使用、保護する方法を説明しています。データのプライバシーとセキュリティの維持に取り組んでいます。",
        "highlights": {
          "title": "主要なプライバシーハイライト：",
          "item1": "サービス提供に必要な情報のみを収集します",
          "item2": "取引データは暗号化され、安全に保存されます",
          "item3": "個人情報を第三者に販売することはありません",
          "item4": "データとプライバシー設定をコントロールできます"
        },
        "viewFull": "完全なプライバシーポリシーを表示"
      },
      "terms": {
        "title": "利用規約",
        "description": "利用規約は、DeepTradeのプラットフォームとサービスの使用を規定しています。プラットフォームを使用することで、これらの条件に同意したことになります。",
        "highlights": {
          "title": "主要な利用規約ハイライト：",
          "item1": "プラットフォーム使用権と制限",
          "item2": "ユーザーの責任と義務",
          "item3": "サービスの可用性と制限",
          "item4": "アカウント終了と停止ポリシー"
        },
        "viewFull": "完全な利用規約を表示"
      },
      "risks": {
        "title": "リスク開示"
      }
    },
    "contact": {
      "title": "サポートにお問い合わせ",
      "form": {
        "name": "名前",
        "email": "メール",
        "subject": "件名",
        "message": "メッセージ",
        "sendMessage": "メッセージを送信",
        "sending": "送信中...",
        "placeholders": {
          "name": "フルネーム",
          "email": "your.email@example.com",
          "subject": "問題の簡単な説明",
          "message": "問題を詳しく説明してください..."
        }
      },
      "guidelines": {
        "title": "サポートガイドライン",
        "before": {
          "title": "サポートに連絡する前に",
          "item1": "まずこのFAQセクションを確認してください",
          "item2": "アカウント設定を確認してください",
          "item3": "API認証情報を確認してください",
          "item4": "既知の問題についてステータスページを確認してください"
        },
        "when": {
          "title": "サポートに連絡する際",
          "item1": "アカウントのメールアドレスを含めてください",
          "item2": "問題を詳しく説明してください",
          "item3": "該当する場合はスクリーンショットを提供してください",
          "item4": "エラーメッセージを含めてください"
        },
        "notice": {
          "title": "重要なお知らせ",
          "message": "秘密鍵、パスワード、またはAPIシークレットキーをお尋ねすることはありません。この情報を安全に保管し、誰とも共有しないでください。"
        }
      },
      "errors": {
        "missingInformation": "情報不足",
        "fillAllFields": "送信前にすべてのフィールドを入力してください。",
        "failedToSend": "メッセージの送信に失敗しました",
        "error": "エラー",
        "tryAgainLater": "メッセージの送信に失敗しました。後でもう一度お試しください。"
      },
      "success": {
        "messageSent": "メッセージが送信されました！",
        "thankYou": "お問い合わせいただきありがとうございます。24-48時間以内にご返信いたします。"
      }
    }
  },
  "redeemCoupon": {
    "title": "クーポンを使用",
    "subtitle": "クーポンコードを入力してティアをアップグレード",
    "currentTier": "現在のティア:",
    "couponCode": "クーポンコード",
    "placeholder": "クーポンコードを入力 (例: DTABC123)",
    "formatHint": "コードは4-20文字、英数字のみ使用可能",
    "redeemButton": "クーポンを使用",
    "redeeming": "使用中...",
    "backToTier": "← ティア管理に戻る",
    "tierNames": {
      "starter": "スターター (無料)",
      "pro": "プロ (プレミアム)",
      "vip": "VIP (エリート)",
      "unknown": "不明"
    },
    "howItWorks": {
      "title": "使用方法:",
      "steps": [
        "上記にクーポンコードを入力",
        "ティアが自動的にアップグレードされます",
        "新機能に即座にアクセス可能",
        "各クーポンは一度のみ使用可能"
      ]
    },
    "errors": {
      "invalidInput": "無効な入力",
      "enterCouponCode": "クーポンコードを入力してください",
      "invalidFormat": "無効な形式",
      "formatRequirement": "クーポンコードは4-20文字、英数字のみ使用可能です",
      "redemptionFailed": "使用に失敗",
      "failedToRedeem": "クーポンの使用に失敗しました",
      "networkError": "ネットワークエラー",
      "connectionFailed": "サーバーへの接続に失敗しました。もう一度お試しください。"
    },
    "success": {
      "redeemed": "クーポンが正常に使用されました！",
      "validFor": "({{days}}日間有効)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "認証中...",
      "description": "認証を完了するまでお待ちください。"
    },
    "error": {
      "title": "認証エラー",
      "returnToLogin": "ログインに戻る",
      "tryAgain": "再試行"
    },
    "completing": {
      "title": "認証完了中",
      "description": "ログイン処理中です。お待ちください..."
    },
    "errors": {
      "authenticationFailed": "認証に失敗しました",
      "noAuthorizationCode": "OAuthプロバイダーから認証コードを受信できませんでした",
      "invalidServerResponse": "サーバーからの無効な応答",
      "unexpectedError": "認証中に予期しないエラーが発生しました",
      "noAdditionalDetails": "追加の詳細情報はありません"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "パスワードは8文字以上である必要があります",
      "uppercase": "パスワードには大文字を1文字以上含める必要があります",
      "lowercase": "パスワードには小文字を1文字以上含める必要があります",
      "number": "パスワードには数字を1文字以上含める必要があります",
      "specialChar": "パスワードには特殊文字を1文字以上含める必要があります"
    },
    "errors": {
      "invalidToken": "無効なトークン",
      "invalidTokenDescription": "このパスワードリセットリンクは無効または期限切れです。",
      "validationFailed": "検証に失敗しました",
      "validationFailedDescription": "リセットトークンの検証に失敗しました。もう一度お試しください。",
      "fillAllFields": "すべてのフィールドを入力してください",
      "passwordsDoNotMatch": "パスワードが一致しません",
      "requirementsNotMet": "パスワード要件が満たされていません",
      "resetFailed": "パスワードのリセットに失敗しました",
      "resetFailedTitle": "リセットに失敗しました"
    },
    "success": {
      "title": "パスワードリセット成功",
      "description": "パスワードが正常に更新されました。",
      "passwordUpdated": "✓ パスワードが更新されました",
      "securityNote": "新しいパスワードでログインできます。セキュリティのため、すべてのデバイスからログアウトされました。",
      "continueToLogin": "ログインに進む"
    },
    "validating": {
      "title": "リセットリンクを検証中",
      "description": "パスワードリセットリンクを検証しています。しばらくお待ちください..."
    },
    "invalid": {
      "title": "無効なリセットリンク",
      "description": "このパスワードリセットリンクは無効または期限切れです。",
      "linkInvalid": "リンクが無効です",
      "reason1": "• リセットリンクの有効期限が切れている可能性があります（リンクは1時間後に期限切れになります）",
      "reason2": "• リンクがすでに使用されている可能性があります",
      "reason3": "• リンクが不正または不完全な可能性があります",
      "requestNewLink": "新しいリセットリンクをリクエスト",
      "backToLogin": "ログインに戻る"
    },
    "form": {
      "title": "パスワードをリセット",
      "description": "{{email}}の新しいパスワードを入力してください",
      "newPassword": "新しいパスワード",
      "newPasswordPlaceholder": "新しいパスワードを入力してください",
      "confirmPassword": "新しいパスワードの確認",
      "confirmPasswordPlaceholder": "新しいパスワードを確認してください",
      "updating": "パスワードを更新中...",
      "updateButton": "パスワードを更新",
      "backToLogin": "ログインに戻る"
    },
    "requirements": {
      "title": "パスワード要件",
      "minLength": "• 8文字以上",
      "caseLetters": "• 大文字と小文字を含む",
      "number": "• 数字を1文字以上含む",
      "specialChar": "• 特殊文字を1文字以上含む (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "このリセットリンクは{{time}}に期限切れになります"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "最後に成功した取引はいつでしたか？",
      "question2": "現在どのティア（1、2、または3）にいますか？",
      "question3": "主にどの取引所を使用していますか？"
    },
    "errors": {
      "fillRequiredFields": "すべての必須フィールドを入力してください（メール、フルネーム、理由）",
      "submitFailed": "2FAリセット要求の送信に失敗しました",
      "requestFailed": "要求に失敗しました"
    },
    "success": {
      "requestSubmitted": "要求が送信されました",
      "title": "要求が送信されました",
      "description": "2FAリセット要求が審査のために提出されました。",
      "submittedSuccessfully": "✓ 要求が正常に送信されました",
      "email": "メール",
      "requestId": "要求ID",
      "status": "ステータス",
      "pendingReview": "審査待ち",
      "whatHappensNext": "次に何が起こりますか？",
      "step1": "1. セキュリティチームが要求と確認情報を審査します",
      "step2": "2. 必要に応じて追加の確認のためにご連絡する場合があります",
      "step3": "3. 処理が完了するとメール通知を受け取ります",
      "step4": "4. 承認されると、2FAが無効になり、再度設定できます",
      "backToLogin": "ログインに戻る",
      "submitAnother": "別の要求を送信"
    },
    "form": {
      "title": "2FAリセット要求",
      "description": "2FAデバイスへのアクセスを失いましたか？セキュリティチームにリセットを要求するには、このフォームに記入してください。",
      "securityNotice": "⚠️ 重要なセキュリティ通知",
      "notice1": "• このプロセスはセキュリティチームによる手動審査が必要です",
      "notice2": "• 確認を迅速化するため、可能な限り正確な情報を提供してください",
      "notice3": "• 虚偽の情報は要求の拒否につながります",
      "notice4": "• 処理時間：1-3営業日",
      "requiredInformation": "必須情報",
      "emailAddress": "メールアドレス *",
      "fullName": "フルネーム *",
      "reason": "2FAリセットの理由 *",
      "additionalVerification": "追加確認（オプションですが推奨）",
      "lastLoginDate": "おおよその最終ログイン日",
      "accountCreationDate": "おおよそのアカウント作成日",
      "recentActivity": "最近のアカウント活動",
      "securityQuestionsTitle": "セキュリティ質問",
      "securityQuestionsDescription": "身元確認のためにこれらの質問に答えてください。わからない場合は空白のままにしてください。",
      "submittingRequest": "要求を送信中...",
      "submitButton": "2FAリセット要求を送信",
      "backToLogin": "ログインに戻る",
      "rememberDevice": "2FAデバイスを覚えていますか？",
      "tryVerification": "2FA認証を試す",
      "placeholders": {
        "email": "アカウントのメールアドレスを入力してください",
        "fullName": "登録されているフルネームを入力してください",
        "reason": "2FAをリセットする必要がある理由を説明してください（例：携帯電話の紛失、デバイスの故障など）",
        "lastLoginDate": "例：2024年12月15日",
        "accountCreationDate": "例：2024年11月",
        "recentActivity": "最近の活動を説明してください（取引、ティア変更、支払いなど）",
        "yourAnswer": "あなたの回答"
      }
    }
  },
  "verify2FA": {
    "title": "二段階認証",
    "description": "6桁の認証コードがメールアドレスに送信されました",
    "form": {
      "verificationCode": "認証コード",
      "placeholder": "6桁のコードを入力",
      "verifying": "認証中...",
      "verifyCode": "コードを認証"
    },
    "errors": {
      "sessionExpired": "セッションが期限切れです",
      "pleaseLoginAgain": "再度ログインしてください。",
      "enterCode": "認証コードを入力してください",
      "codeMustBe6Digits": "認証コードは6桁である必要があります",
      "verificationFailed": "認証に失敗しました",
      "verificationFailedTitle": "認証に失敗しました",
      "invalidCode": "無効な認証コード",
      "failedToResendCode": "コードの再送信に失敗しました",
      "failedToResendTitle": "再送信に失敗しました"
    },
    "success": {
      "loginSuccessful": "ログイン成功",
      "welcomeBack": "おかえりなさい！",
      "codeSent": "コードを送信しました",
      "codeSentDescription": "新しい認証コードがメールに送信されました。"
    },
    "help": {
      "needHelp": "ヘルプが必要ですか？",
      "sending": "送信中...",
      "resendCode": "コードを再送信",
      "backToLogin": "ログインに戻る",
      "lostDevice": "2FAデバイスを紛失？リセットをリクエスト",
      "didntReceiveCode": "コードを受信できませんでしたか？スパムフォルダを確認するか",
      "resendIt": "再送信してください",
      "byContinuing": "続行することで、以下に同意したことになります",
      "termsOfService": "利用規約",
      "privacyPolicy": "プライバシーポリシー"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "メールアドレスが必要です",
      "sendFailed": "パスワードリセットメールの送信に失敗しました",
      "requestFailed": "リクエストに失敗しました"
    },
    "success": {
      "emailSent": "リセットメールを送信しました",
      "title": "メールを確認してください",
      "description": "このメールアドレスでアカウントが存在する場合、パスワードリセットリンクを受信します。",
      "emailSentTitle": "メールを送信しました",
      "emailSentMessage": "アカウントが存在する場合、{{email}}にパスワードリセットリンクを送信しました。",
      "instruction1": "• メールが表示されない場合は、スパム/迷惑メールフォルダを確認してください",
      "instruction2": "• リセットリンクは1時間で期限切れになります",
      "instruction3": "• 必要に応じて別のリセットをリクエストできます",
      "sendAnother": "別のリセットメールを送信",
      "backToLogin": "ログインに戻る"
    },
    "form": {
      "title": "パスワードを忘れた場合",
      "description": "メールアドレスを入力すると、パスワードをリセットするためのリンクをお送りします。",
      "emailAddress": "メールアドレス",
      "placeholder": "メールアドレスを入力してください",
      "sending": "送信中...",
      "sendResetLink": "リセットリンクを送信",
      "backToLogin": "ログインに戻る",
      "noAccount": "アカウントをお持ちでないですか？",
      "signUp": "サインアップ",
      "lost2FA": "2FAデバイスへのアクセスを失いましたか？",
      "request2FAReset": "2FAリセットをリクエスト"
    },
    "security": {
      "title": "セキュリティ注意事項",
      "note1": "• パスワードリセットは従来のアカウントでのみ利用可能です",
      "note2": "• Google OAuthユーザーは「Googleでサインイン」を使用してください",
      "note3": "• リセットリンクはセキュリティのため1時間後に期限切れになります"
    }
  }
};
